// extracted by mini-css-extract-plugin
module.exports = {"signerForm":"styles_signerForm__sYhRk","disabledPill":"styles_disabledPill__U7jm5"};